import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.629 5.65q4.266-.317 8.24-.317 4.068 0 8.136.331a4.28 4.28 0 0 1 3.915 3.89q.19 2.176.191 4.946 0 2.834-.2 5.243a4.28 4.28 0 0 1-4.263 3.924H9.944a4.28 4.28 0 0 1-4.277-4.278V9.915c0-2.24 1.728-4.1 3.962-4.266m13.76 20.461a.611.611 0 0 1 0 1.222H8.722A6.72 6.72 0 0 1 2 20.611v-8.556a.611.611 0 0 1 1.222 0v8.556a5.5 5.5 0 0 0 5.5 5.5zM6.889 9.915c0-1.6 1.234-2.929 2.83-3.047a111 111 0 0 1 8.15-.313q4.02 0 8.037.327a3.056 3.056 0 0 1 2.796 2.778q.187 2.12.187 4.84 0 2.784-.196 5.142a3.055 3.055 0 0 1-3.045 2.802H9.945a3.056 3.056 0 0 1-3.056-3.055z",
      clipRule: "evenodd"
    }
  )
);
var SvgShareScreenOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ShareScreenOutlined_default = SvgShareScreenOutlined;

export { ShareScreenOutlined_default as default };
